import { useEffect, useRef, useState } from "react";

const API = "/api";
const token = () => localStorage.getItem("token");

export default function VentaCredito() {
  const [clientes, setClientes] = useState<any[]>([]);
  const [productos, setProductos] = useState<any[]>([]);
  const [clienteId, setClienteId] = useState<string>("");
  const [busquedaCliente, setBusquedaCliente] = useState("");
  const [mostrarSugerenciasCliente, setMostrarSugerenciasCliente] = useState(false);
  const [busqueda, setBusqueda] = useState("");
  const [carrito, setCarrito] = useState<any[]>([]);
  // item: { key, producto_id|null, nombre, precio, cantidad, stock|null, imagen_url|null, descripcion|null, esCustom }
  const [notas, setNotas] = useState("");
  const [abonoInicial, setAbonoInicial] = useState("");
  const [metodoPagoInicial, setMetodoPagoInicial] = useState("efectivo");
  const [enviando, setEnviando] = useState(false);
  const [mensaje, setMensaje] = useState<any>(null);

  // formulario "producto fuera de catálogo"
  const [mostrarCustom, setMostrarCustom] = useState(false);
  const [customForm, setCustomForm] = useState({ nombre: "", descripcion: "", precio: "", cantidad: "1", imagen_url: "" });
  const [subiendoImagen, setSubiendoImagen] = useState(false);
  const [mostrarGaleria, setMostrarGaleria] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    fetch(`${API}/creditos/clientes?activo=true`, { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json()).then(d => Array.isArray(d) && setClientes(d)).catch(() => {});
    fetch(`${API}/productos/`, { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json()).then(d => Array.isArray(d) && setProductos(d)).catch(() => {});
  }, []);

  const productosFiltrados = productos.filter(p =>
    p.nombre.toLowerCase().includes(busqueda.toLowerCase())
  ).slice(0, 8);

  const sugerenciasClientes = (busquedaCliente.trim() === ""
    ? clientes
    : clientes.filter(c =>
        c.nombre?.toLowerCase().includes(busquedaCliente.trim().toLowerCase()) ||
        (c.cedula && c.cedula.toLowerCase().includes(busquedaCliente.trim().toLowerCase()))
      )
  ).slice(0, 8);

  const elegirCliente = (c: any) => {
    setClienteId(String(c.id));
    setBusquedaCliente(c.nombre);
    setMostrarSugerenciasCliente(false);
  };

  const agregarProducto = (p: any) => {
    const existente = carrito.find(i => i.producto_id === p.id);
    if (existente) {
      setCarrito(carrito.map(i => i.producto_id === p.id ? { ...i, cantidad: i.cantidad + 1 } : i));
    } else {
      setCarrito([...carrito, {
        key: `p-${p.id}`, producto_id: p.id, nombre: p.nombre,
        precio: p.precio_oferta || p.precio, cantidad: 1, stock: p.stock, esCustom: false,
      }]);
    }
    setBusqueda("");
  };

  const agregarCustom = () => {
    if (!customForm.nombre || !customForm.precio) return;
    setCarrito([...carrito, {
      key: `c-${Date.now()}`, producto_id: null,
      nombre: customForm.nombre, descripcion: customForm.descripcion,
      precio: Number(customForm.precio), cantidad: Number(customForm.cantidad) || 1,
      stock: null, imagen_url: customForm.imagen_url || null, esCustom: true,
    }]);
    setCustomForm({ nombre: "", descripcion: "", precio: "", cantidad: "1", imagen_url: "" });
    setMostrarCustom(false);
  };

  const subirFoto = async (file: File) => {
    setSubiendoImagen(true);
    const fd = new FormData();
    fd.append("file", file);
    const r = await fetch(`${API}/creditos/upload-imagen`, {
      method: "POST", headers: { Authorization: `Bearer ${token()}` }, body: fd,
    });
    setSubiendoImagen(false);
    if (r.ok) {
      const data = await r.json();
      setCustomForm(f => ({ ...f, imagen_url: data.imagen_url }));
    } else {
      alert("No se pudo subir la imagen");
    }
  };

  const cambiarCantidad = (key: string, cantidad: number) => {
    setCarrito(carrito.map(i => {
      if (i.key !== key) return i;
      const max = i.stock != null ? undefined : undefined; // sin límite, stock puede quedar negativo
      return { ...i, cantidad: Math.max(1, cantidad) };
    }));
  };

  const quitar = (key: string) => setCarrito(carrito.filter(i => i.key !== key));

  const total = carrito.reduce((s, i) => s + i.precio * i.cantidad, 0);

  const confirmarVenta = async () => {
    if (!clienteId || carrito.length === 0) return;
    setEnviando(true);
    setMensaje(null);
    const items = carrito.map(i => i.esCustom ? {
      producto_id: null,
      nombre_personalizado: i.nombre,
      descripcion: i.descripcion || null,
      precio_unitario: i.precio,
      imagen_url: i.imagen_url || null,
      cantidad: i.cantidad,
    } : {
      producto_id: i.producto_id,
      cantidad: i.cantidad,
    });

    const r = await fetch(`${API}/creditos/ventas`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token()}` },
      body: JSON.stringify({
        cliente_id: Number(clienteId), items, notas,
        abono_inicial: abonoInicial ? Number(abonoInicial) : null,
        metodo_pago_inicial: metodoPagoInicial,
      }),
    });
    const data = await r.json();
    setEnviando(false);
    if (r.ok) {
      setMensaje({ tipo: "ok", texto: `Venta #${data.id} registrada. Saldo: ₡${data.saldo_pendiente?.toLocaleString()}.${data.proxima_fecha_pago ? ` Próximo pago: ${data.proxima_fecha_pago}` : " Pagada por completo."}` });
      setCarrito([]);
      setClienteId("");
      setBusquedaCliente("");
      setNotas("");
      setAbonoInicial("");
      setMetodoPagoInicial("efectivo");
      fetch(`${API}/productos/`, { headers: { Authorization: `Bearer ${token()}` } })
        .then(r2 => r2.json()).then(d => Array.isArray(d) && setProductos(d)).catch(() => {});
    } else {
      setMensaje({ tipo: "error", texto: data.detail || "No se pudo registrar la venta" });
    }
  };

  const input = { width: "100%", padding: "10px 12px", borderRadius: "10px", border: "1.5px solid #e5e7eb", fontSize: "14px", fontFamily: "Nunito,sans-serif", boxSizing: "border-box" as const };
  const label = { display: "block", fontSize: "12px", fontWeight: 700, color: "#6b7280", marginBottom: "4px" };

  return (
    <div>
      <h1 style={{ fontFamily: "Montserrat,sans-serif", fontSize: "24px", fontWeight: 900, marginBottom: "24px", color: "#1a1a2e" }}>
        Nueva Venta a Crédito
      </h1>

      {mensaje && (
        <div style={{ background: mensaje.tipo === "ok" ? "#ECFDF5" : "#FEF2F2", color: mensaje.tipo === "ok" ? "#065F46" : "#991B1B", padding: "14px 18px", borderRadius: "12px", marginBottom: "20px", fontWeight: 600, fontSize: "14px" }}>
          {mensaje.texto}
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .vc-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>

      <div className="vc-grid" style={{ display: "grid", gridTemplateColumns: "1.2fr 1fr", gap: "20px" }}>
        {/* Columna izquierda: cliente + búsqueda de productos */}
        <div style={{ background: "#fff", borderRadius: "16px", padding: "20px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
          <label style={label}>Cliente *</label>
          <div style={{ position: "relative", marginBottom: "16px" }}>
            <input
              style={input}
              placeholder="Escribí el nombre o cédula del cliente..."
              value={busquedaCliente}
              onChange={e => {
                setBusquedaCliente(e.target.value);
                setMostrarSugerenciasCliente(true);
                if (e.target.value.trim() === "") setClienteId("");
              }}
              onFocus={() => setMostrarSugerenciasCliente(true)}
              onBlur={() => setTimeout(() => setMostrarSugerenciasCliente(false), 150)}
            />
            {mostrarSugerenciasCliente && sugerenciasClientes.length > 0 && (
              <div style={{ position: "absolute", zIndex: 10, marginTop: "4px", width: "100%", maxHeight: "220px", overflowY: "auto", background: "#fff", border: "1.5px solid #e5e7eb", borderRadius: "10px", boxShadow: "0 4px 12px rgba(0,0,0,0.10)" }}>
                {sugerenciasClientes.map(c => (
                  <div key={c.id}
                    onMouseDown={() => elegirCliente(c)}
                    style={{ padding: "10px 14px", cursor: "pointer", fontSize: "14px", background: String(c.id) === clienteId ? "#F3F4F6" : "transparent", fontWeight: String(c.id) === clienteId ? 700 : 400 }}>
                    {c.nombre}{c.cedula ? ` (${c.cedula})` : ""}
                  </div>
                ))}
              </div>
            )}
            {mostrarSugerenciasCliente && busquedaCliente.trim() !== "" && sugerenciasClientes.length === 0 && (
              <div style={{ position: "absolute", zIndex: 10, marginTop: "4px", width: "100%", background: "#fff", border: "1.5px solid #e5e7eb", borderRadius: "10px", padding: "10px 14px", fontSize: "13px", color: "#9ca3af" }}>
                Ningún cliente coincide.
              </div>
            )}
          </div>

          <label style={label}>Buscar producto del catálogo</label>
          <input style={input} placeholder="Escribí el nombre del producto..." value={busqueda}
            onChange={e => setBusqueda(e.target.value)} />

          {busqueda && (
            <div style={{ marginTop: "10px", display: "flex", flexDirection: "column", gap: "6px" }}>
              {productosFiltrados.map(p => (
                <div key={p.id} onClick={() => agregarProducto(p)}
                  style={{ padding: "10px 14px", background: "#F9FAFB", borderRadius: "10px", cursor: "pointer", display: "flex", justifyContent: "space-between", fontSize: "14px" }}>
                  <span>{p.nombre}</span>
                  <span style={{ color: p.stock > 0 ? "#6b7280" : "#ef4444" }}>
                    ₡{(p.precio_oferta || p.precio)?.toLocaleString()} · stock {p.stock}
                    {p.stock <= 0 && " (sin stock)"}
                  </span>
                </div>
              ))}
              {productosFiltrados.length === 0 && <div style={{ color: "#9ca3af", fontSize: "13px", padding: "8px" }}>Sin resultados</div>}
            </div>
          )}

          <div style={{ marginTop: "16px", paddingTop: "16px", borderTop: "1px dashed #e5e7eb" }}>
            <button onClick={() => setMostrarCustom(!mostrarCustom)}
              style={{ background: "#FFF7ED", color: "#C2410C", border: "1.5px dashed #FDBA74", borderRadius: "10px", padding: "10px 16px", fontWeight: 700, fontSize: "13px", cursor: "pointer", width: "100%", fontFamily: "Nunito,sans-serif" }}>
              {mostrarCustom ? "Cancelar" : "➕ Producto fuera de catálogo"}
            </button>

            {mostrarCustom && (
              <div style={{ marginTop: "12px", background: "#FFF7ED", borderRadius: "12px", padding: "16px" }}>
                <label style={label}>Nombre / descripción rápida *</label>
                <input style={{ ...input, marginBottom: "10px" }} value={customForm.nombre}
                  onChange={e => setCustomForm({ ...customForm, nombre: e.target.value })} />

                <label style={label}>Detalle adicional (opcional)</label>
                <input style={{ ...input, marginBottom: "10px" }} value={customForm.descripcion}
                  onChange={e => setCustomForm({ ...customForm, descripcion: e.target.value })} />

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", marginBottom: "10px" }}>
                  <div>
                    <label style={label}>Monto *</label>
                    <input type="number" style={input} value={customForm.precio}
                      onChange={e => setCustomForm({ ...customForm, precio: e.target.value })} />
                  </div>
                  <div>
                    <label style={label}>Cantidad</label>
                    <input type="number" min={1} style={input} value={customForm.cantidad}
                      onChange={e => setCustomForm({ ...customForm, cantidad: e.target.value })} />
                  </div>
                </div>

                <label style={label}>Foto (opcional)</label>
                <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                  <button onClick={() => fileInputRef.current?.click()} disabled={subiendoImagen}
                    style={{ flex: 1, background: "#fff", border: "1.5px solid #FDBA74", borderRadius: "8px", padding: "8px", fontSize: "12px", fontWeight: 700, cursor: "pointer", color: "#C2410C" }}>
                    {subiendoImagen ? "Subiendo..." : "📷 Subir foto"}
                  </button>
                  <button onClick={() => setMostrarGaleria(!mostrarGaleria)}
                    style={{ flex: 1, background: "#fff", border: "1.5px solid #FDBA74", borderRadius: "8px", padding: "8px", fontSize: "12px", fontWeight: 700, cursor: "pointer", color: "#C2410C" }}>
                    🖼️ Usar foto existente
                  </button>
                </div>
                <input ref={fileInputRef} type="file" accept="image/*" style={{ display: "none" }}
                  onChange={e => e.target.files && e.target.files[0] && subirFoto(e.target.files[0])} />

                {mostrarGaleria && (
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "6px", marginBottom: "8px", maxHeight: "160px", overflowY: "auto" }}>
                    {productos.filter(p => p.imagen_url).map(p => (
                      <img key={p.id} src={p.imagen_url} title={p.nombre}
                        onClick={() => { setCustomForm(f => ({ ...f, imagen_url: p.imagen_url })); setMostrarGaleria(false); }}
                        style={{ width: "100%", height: "50px", objectFit: "cover", borderRadius: "6px", cursor: "pointer", border: customForm.imagen_url === p.imagen_url ? "2px solid #C2410C" : "1px solid #e5e7eb" }} />
                    ))}
                  </div>
                )}

                {customForm.imagen_url && (
                  <img src={customForm.imagen_url} style={{ width: "60px", height: "60px", objectFit: "cover", borderRadius: "8px", marginBottom: "8px" }} />
                )}

                <button onClick={agregarCustom} disabled={!customForm.nombre || !customForm.precio}
                  style={{ width: "100%", background: "#C2410C", color: "#fff", border: "none", borderRadius: "8px", padding: "10px", fontWeight: 800, cursor: (customForm.nombre && customForm.precio) ? "pointer" : "not-allowed", opacity: (customForm.nombre && customForm.precio) ? 1 : 0.5, fontFamily: "Nunito,sans-serif" }}>
                  Agregar al carrito
                </button>
              </div>
            )}
          </div>

          <label style={{ ...label, marginTop: "16px" }}>Notas (opcional)</label>
          <textarea style={{ ...input, minHeight: "60px" }} value={notas} onChange={e => setNotas(e.target.value)} />
        </div>

        {/* Columna derecha: carrito */}
        <div style={{ background: "#fff", borderRadius: "16px", padding: "20px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", display: "flex", flexDirection: "column" }}>
          <div style={{ fontWeight: 800, fontSize: "16px", marginBottom: "12px" }}>Carrito ({carrito.length})</div>
          <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "10px", minHeight: "120px" }}>
            {carrito.map(i => (
              <div key={i.key} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px", background: i.esCustom ? "#FFF7ED" : "#F9FAFB", borderRadius: "10px" }}>
                {i.imagen_url && <img src={i.imagen_url} style={{ width: "34px", height: "34px", objectFit: "cover", borderRadius: "6px", marginRight: "8px" }} />}
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700, fontSize: "13px" }}>{i.nombre} {i.esCustom && <span style={{ fontSize: "10px", color: "#C2410C" }}>· fuera de catálogo</span>}</div>
                  <div style={{ fontSize: "12px", color: "#6b7280" }}>
                    ₡{i.precio.toLocaleString()} c/u {i.stock != null && i.stock < i.cantidad && <span style={{ color: "#ef4444", fontWeight: 700 }}>· stock insuficiente</span>}
                  </div>
                </div>
                <input type="number" min={1} value={i.cantidad}
                  onChange={e => cambiarCantidad(i.key, Number(e.target.value))}
                  style={{ width: "50px", padding: "6px", borderRadius: "6px", border: "1px solid #e5e7eb", textAlign: "center", marginRight: "8px" }} />
                <div style={{ fontWeight: 800, fontSize: "13px", width: "80px", textAlign: "right" }}>
                  ₡{(i.precio * i.cantidad).toLocaleString()}
                </div>
                <button onClick={() => quitar(i.key)} style={{ background: "none", border: "none", color: "#ef4444", cursor: "pointer", fontSize: "18px", marginLeft: "8px" }}>×</button>
              </div>
            ))}
            {carrito.length === 0 && <div style={{ color: "#9ca3af", fontSize: "13px", textAlign: "center", padding: "20px" }}>Agregá productos desde la izquierda</div>}
          </div>

          <div style={{ borderTop: "2px solid #f3f4f6", marginTop: "16px", paddingTop: "16px" }}>
            <label style={label}>Enganche / pago inicial (opcional)</label>
            <div style={{ display: "flex", gap: "8px", marginBottom: "12px" }}>
              <input type="number" min={0} max={total} placeholder="₡0" value={abonoInicial}
                onChange={e => setAbonoInicial(e.target.value)}
                style={{ ...input, flex: 1 }} />
              <select value={metodoPagoInicial} onChange={e => setMetodoPagoInicial(e.target.value)}
                style={{ ...input, flex: 1 }}>
                <option value="efectivo">Efectivo</option>
                <option value="sinpe">Sinpe Móvil</option>
                <option value="transferencia">Transferencia</option>
                <option value="tarjeta">Tarjeta</option>
              </select>
            </div>

            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "4px", fontSize: "13px", color: "#6b7280" }}>
              <span>Total de la venta</span>
              <span>₡{total.toLocaleString()}</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "16px" }}>
              <span style={{ fontWeight: 700 }}>Saldo a crédito</span>
              <span style={{ fontFamily: "Montserrat,sans-serif", fontWeight: 900, fontSize: "22px", color: "#1565C0" }}>
                ₡{Math.max(0, total - (Number(abonoInicial) || 0)).toLocaleString()}
              </span>
            </div>
            <button onClick={confirmarVenta} disabled={!clienteId || carrito.length === 0 || enviando}
              style={{ width: "100%", background: "#0D47A1", color: "#fff", border: "none", borderRadius: "12px", padding: "14px", fontWeight: 800, fontSize: "15px", cursor: (!clienteId || carrito.length === 0) ? "not-allowed" : "pointer", opacity: (!clienteId || carrito.length === 0) ? 0.5 : 1, fontFamily: "Nunito,sans-serif" }}>
              {enviando ? "Procesando..." : "Confirmar Venta a Crédito"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
